// extracted by mini-css-extract-plugin
export default {"app":"App__app___mApNY"};